/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

import React from 'react';
import $ from 'jquery';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'underscore';

import { xhrfileupload } from '../xhrfileupload';
import { Library } from './photo_chooser/library.jsx';

import { NoPhoto } from './photo_chooser/no_photo.jsx';
import { Photo } from './photo_chooser/photo.jsx';

export class PhotoChooser extends React.Component {
        static propTypes = {
            initial_photo: PropTypes.object,
            upload_url: PropTypes.string.isRequired,
            library_url: PropTypes.string,
            aspect: PropTypes.number,
            caption: PropTypes.string,
            can_remove: PropTypes.bool,
            can_choose: PropTypes.bool,
            can_upload: PropTypes.bool,
            can_crop: PropTypes.bool,
            force_cropping: PropTypes.bool,
            crop_area_name: PropTypes.string,
            crop_area_param: PropTypes.string,
            onPhotoSelected: PropTypes.func,
            onPhotoRemoved: PropTypes.func,
            dropzoneComponent: PropTypes.func,
            showCropEditorLink: PropTypes.bool,
            showEditorLink: PropTypes.bool,
            allowCaptionEdit: PropTypes.bool,
            requireCaption: PropTypes.bool,
            captionError: PropTypes.bool,
            captionLabel: PropTypes.string,
            aiAltTextEnabled: PropTypes.bool,
            aiAltTextAnalyticsCategory: PropTypes.string,
            aiAltTextBtnClass: PropTypes.string,
            aiAltTextFieldClass: PropTypes.string,
            aiAltTextModalBtnClasses: PropTypes.object,
            generateAltTextUrl: PropTypes.string,
            register: PropTypes.func,
            onCropChange: PropTypes.func,
            onCaptionChange: PropTypes.func,
            cropOverride: PropTypes.object,
            onZoomEnd: PropTypes.func
        };

        static defaultProps = {
            can_remove: true,
            can_choose: true,
            can_upload: true,
            can_crop: true,
            aspect: 1.0,
            force_cropping: false,
            showCropEditorLink: true,
            allowCaptionEdit: true,
            requireCaption: false,
            captionError: false,
            aiAltTextEnabled: false,
            aiAltTextAnalyticsCategory: null,
            aiAltTextBtnClass: null,
            aiAltTextFieldClass: null,
            aiAltTextModalBtnClasses: {},
            generateAltTextUrl: '/photos/generate_alt_text'
        };

        constructor(props) {
          super(props);
          this.UNSAFE_componentWillReceiveProps = this.UNSAFE_componentWillReceiveProps.bind(this);
          this._initialPhotoState = this._initialPhotoState.bind(this);
          this.imageSelected = this.imageSelected.bind(this);
          this.imageUploaded = this.imageUploaded.bind(this);
          this.imageRemoved = this.imageRemoved.bind(this);
          this.setPhoto = this.setPhoto.bind(this);
          this.libraryOpened = this.libraryOpened.bind(this);
          this.libraryClosed = this.libraryClosed.bind(this);
          this.libraryPhotoSelected = this.libraryPhotoSelected.bind(this);
this.setRef = this.setRef.bind(this);

          const initial_state = this._initialPhotoState(props);
          _.extend(initial_state, {
            // Upload status
            upload_status: 'ok',
            upload_status_message: null,
            upload_progress: 0,

            // Library status
            recent_items: [],
            library_items: [],
            library_loaded: false,
            library_status: null
          }
          ); // null or 'error'

          this.state = initial_state;
        }

        UNSAFE_componentWillReceiveProps(nextProps) {
          if (this.props.initial_photo !== nextProps.initial_photo) {
            return this.setState(this._initialPhotoState(nextProps));
          }
        }

        _initialPhotoState(props) {
            // Mode indicator
            //
            // Can be one of:
            //   none: No photo selected (with uploads)
            //   photo: Photo selected (optional cropper)
            //   library: Choosing from photo library
            return {
              mode: props.initial_photo.photo ? 'photo' : 'none',

              // Data about the currently selected photo
              photo: props.initial_photo.photo,
              photo_key: props.initial_photo.key,
              crop: props.initial_photo.crop,
              edit_cropping_url: props.initial_photo.edit_cropping_url,
              edit_url: props.initial_photo.edit_url,

              // Flags to enable/disable features
              allow_cropping: props.force_cropping || (props.can_crop && props.initial_photo.allow_cropping),
              allow_remove: props.can_remove,
              allow_choose: props.can_choose
            };
          }

        // User chose image to upload, so upload it via XHR and include the form data
        imageSelected(file) {
          // Perform upload
          const form = $(this.element).closest('form');

          // Gather the rest of the form data
          //
          // Most of this isn't actually used, but it's somewhat useful in the logs for diagnostic purposes
          let formData = null;
          try {
            // Prefer native serialization
            formData = new FormData(form.get(0));
          } catch (error) {
            // But, IE10 fails, so fake the serialization on it
            formData = new FormData();
            form.find('input,select,textarea').each(function(i) {
              if ((this.name === 'photo') || (this.name === 'event[photo]')) { return; }
              if (this.disabled) { return; }
              if (!this.checked && ((this.type === 'checkbox') || (this.type === 'radio'))) { return; }

              const the_value = this.type === 'file' ?
                this.files[0]
              :
                this.value;

              return formData.append(this.name, the_value);
            });
          }

          // Clean up some unnecessary fields

          // IE10 doesn't support delete (??)
          if (typeof formData.delete === 'function') {
            formData.delete('photo');
          }
          if (typeof formData.delete === 'function') {
            formData.delete('event[photo]');
          }
          formData.append('_timestamp', new Date);

          this.setState({
            upload_status: 'uploading',
            upload_status_message: null,
            upload_progress: 0
          });

          return xhrfileupload({
            url: this.props.upload_url,
            method: 'POST',
            formData,
            file,
            param: 'photo',
            progress: event => {
              if (event.lengthComputable) {
                const percent = Math.round((event.loaded / event.total) * 100);
                return this.setState({upload_progress: percent});
              }
            }}).fail((xhr, status, error) => {
            let error_message;
            console.error('file upload error', status, error, xhr);
            if (status === 'parsererror') {
              // Parse error. Indicates a non-JSON response
              error_message = "Error uploading photo: unexpected response";
            } else {
              if (xhr.status === 413) {
                error_message = 'Image must be smaller than 10MB';
              } else {
                error_message = `Error uploading photo (${xhr.status}: ${error})`;
              }
            }

            return this.setState({upload_status: 'error', upload_status_message: error_message});
              }).done((data, status, xhr) => {
            if (data.status === 'error') {
              const message = data.error === 'not_an_image' ?
                          "Uploaded file must be an image (JPG, GIF, or PNG)"
                        : data.error === 'image_too_big' ?
                          "Image must be smaller than 10MB"
                        : data.error === 'image_dimensions_too_big' ?
                          "Image must be smaller than 5000x5000 pixels"
                        :
                          data.result.message;
              return this.setState({upload_status: 'error', upload_status_message: message});
            } 
              this.setState({upload_status: 'ok', upload_status_message: null});
              return this.imageUploaded(data);
            
          });
        }

        // Image succesfully uploaded response handler
        imageUploaded(response) {
          const new_photo = $.extend({}, this.state.photo, {
            has_crop: false,
            width: response.metadata.width,
            height: response.metadata.height,
            id: null,
            library_id: null,
            preview_url: response.url,
            preview_width: response.metadata.width,
            preview_height: response.metadata.height,
            key: response.token
          }
          );

          return this.setPhoto(new_photo);
        }

        // User cleared selected image
        imageRemoved(event) {
          this.setState({
            photo: null,
            crop: null,
            photo_key: 'deleted',
            mode: 'none'
          });

          // Emit the event indicating the photo was removed
          //
          // This eventually gets picked up by Eventreach
          $(this.element).trigger('slzr:photo:remove');

          // And finally, call the callback function
          return (typeof this.props.onPhotoRemoved === 'function' ? this.props.onPhotoRemoved() : undefined);
        }

        // Set the selected photo
        setPhoto(new_photo, crop = null) {
          // If no cropping, set to cover the whole photo
          //
          // This eventually gets center cropped to the right aspect ratio. Not specifying it causes the cropper to
          // do something totally unintended.
          const new_crop = crop || {x: 0, y: 0, h: new_photo.height, w: new_photo.width};

          const new_state = {
            photo: new_photo,
            crop: new_crop,
            photo_key: new_photo.key,
            mode: 'photo',
            allow_cropping: this.props.force_cropping || (this.props.can_crop && !new_photo.photo_library_id),
            edit_cropping_url: new_photo.edit_cropping_url,
            edit_url: new_photo.edit_url
          };
          this.setState(new_state);

          $(this.element).trigger('slzr:photo:change');
          return (typeof this.props.onPhotoSelected === 'function' ? this.props.onPhotoSelected(new_photo, { state: new_state }) : undefined);
        }

        // User opened the photo library
        libraryOpened(event) {
          if (!this.state.library_loaded) {
            // Request library contents
            $.get(this.props.library_url).then(result => {
              return this.setState({
                library_loaded: true,
                // Empty or falsy values will break the photo chooser LOC-1549
                library_items: result.library && result.library.filter(library_item => library_item && !$.isEmptyObject(library_item)),
                recent_items: result.recent || [],
                library_status: null
              });
          }).fail((xhr, status, error) => {
              return this.setState({
                library_loaded: false,
                library_items: [],
                recent_items: [],
                library_status: 'error'
              });
            });
          }

          return this.setState({
            mode: 'library',
            upload_status: null,
            upload_status_message: null
          });
        }


        // User closed the photo library
        libraryClosed(event) {
          return this.setState({
            mode: 'none',
            library_status: null
          });
        }

        // User chose a photo from the library
        libraryPhotoSelected(photo, event) {
          const new_crop = photo.has_crop ?
            {x: photo.crop_x, y: photo.crop_y, h: photo.crop_h, w: photo.crop_w}
          :
            null;

          return this.setPhoto(photo, new_crop);
        }

        setRef(el) { return this.element = el; }
      
        // Render with a selected photo
        renderPhoto() {
          return <Photo photo={this.state.photo}
                  crop={this.props.cropOverride ? this.props.cropOverride : this.state.crop}
                  key={this.state.photo_key}
                  photoKey={this.state.photo_key}
                  cropAreaParam={this.props.crop_area_param}
                  cropAreaName={this.props.crop_area_name}
                  allowCropping={this.state.allow_cropping}
                  allowRemove={this.state.allow_remove}
                  onRemove={this.imageRemoved}
                  aspect={this.props.aspect == -1 ? (this.state.photo.width / this.state.photo.height) : this.props.aspect}
                  height={this.props.height}
                  width={this.props.width}
                  editCroppingUrl={this.state.edit_cropping_url}
                  editUrl={this.state.edit_url}
                  showCropEditorLink={this.props.showCropEditorLink && this.state.allow_cropping}
                  showEditorLink={this.props.showEditorLink}
                  allowCaptionEdit={this.props.allowCaptionEdit}
                  requireCaption={this.props.requireCaption}
                  captionLabel={this.props.captionLabel}
                  captionError={this.props.captionError}
                  aiAltTextEnabled={this.props.aiAltTextEnabled}
                  aiAltTextAnalyticsCategory={this.props.aiAltTextAnalyticsCategory}
                  aiAltTextBtnClass={this.props.aiAltTextBtnClass}
                  aiAltTextFieldClass={this.props.aiAltTextFieldClass}
                  aiAltTextModalBtnClasses={this.props.aiAltTextModalBtnClasses}
                  generateAltTextUrl={this.props.generateAltTextUrl}
                  onCropChange={this.props.onCropChange}
                  onCropEnd={this.props.onCropEnd}
                  onZoomEnd={this.props.onZoomEnd}
                  onCaptionChange={this.props.onCaptionChange}
                  caption={this.props.caption}
                  forceCropOverride={this.props.cropOverride}
          />;
        }

        // Render the choose from library (or nothing when blank)
        renderLibrary() {
          if (this.state.library_loaded && (this.state.library_items.length === 0) && (this.state.recent_items.length === 0)) {
            //;// No recents or library, so show an appropriate message asking to upload
            return <NoPhoto imageSelected={this.imageSelected}
                      showingEmpty={true}
                      onClose={this.libraryClosed}
                      uploading={this.state.upload_status == 'uploading'}
                      uploadProgress={this.state.upload_progress}
            />;
          } 
            return <Library libraryItems={this.state.library_items}
                      recentItems={this.state.recent_items}
                      loading={!this.state.library_loaded}
                      error={this.state.library_status == 'error'}
                      onPhotoSelected={this.libraryPhotoSelected}
                      onClose={this.libraryClosed}
            />;
          
        }

        // Render empty message
        renderEmpty() {
          return <NoPhoto imageSelected={this.imageSelected}
                    libraryOpened={this.libraryOpened}
                    uploading={this.state.upload_status == 'uploading'}
                    uploadProgress={this.state.upload_progress}
                    allowChoose={this.state.allow_choose}
                    dropzoneComponent={this.props.dropzoneComponent}
          />;
        }

        // Main render function
        render() {
          const content = this.state.mode === 'photo' ?
            this.renderPhoto()
          : this.state.mode === 'library' ?
            this.renderLibrary()
          : // Fallback
            this.renderEmpty();

          const upload_status_classes = classNames('photo_upload_status',
            {error: this.state.upload_status === 'error'});

          const upload_status = <div className={upload_status_classes}>{this.state.upload_status_message}</div>;

          const name = "photo_key";
          const register = this.props.register ? this.props.register(name) : {};

          return <div className="photo-chooser" ref={this.setRef}>
            <input {...register} type="hidden" name={name} value={this.state.photo_key} />
            {content}
            {upload_status}
          </div>;
        }
}
